<script lang="ts">
import Vue from 'vue';
import CopilotButton from './CopilotButton.vue';
import CopilotChat from './CopilotChat.vue';

export default Vue.extend({
  name: 'CopilotMain',
  components: { CopilotChat, CopilotButton },
  props: {
    agentName:{
      type: String,
      required: false
    },
    threadId: {
      type: String,
      required: true,
      default: '',
    },
    user_email: {
      type: String,
      required: true,
      default: 'ademicon@organia.ai',
    },
    requester_id: {
      type: String,
      required: true,
      default: '2004',
    },
    agentId: {
      type: String,
      required: true,
      default: '1',
    },
    stream: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChatOpen: false,
      isDark: false,
    };
  },
  methods: {
    _openChat() {
      this.isChatOpen = true;
    },
  },
});
</script>

<template>
  <section class="copilot-main">
    <CopilotChat 
      :open="isChatOpen" 
      :dark="isDark"
      :agentName="agentName"
      :threadId="threadId" 
      :user_email="user_email"
      :requester_id="requester_id"
      :agentId="agentId"
      :stream="stream"
      @close="isChatOpen = false" 
     />
    <CopilotButton v-if="!isChatOpen" @open="_openChat" />
  </section>
</template>
